import { Component, OnDestroy, OnInit } from '@angular/core';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { IDatafieldComponent } from '../datafield.interface';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DatafieldsEnum } from '../datafield.enum';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';

@Component({
  selector: 'app-datafield-boolean',
  templateUrl: './datafield-boolean.component.html',
  styleUrls: ['./datafield-boolean.component.scss']
})
export class DatafieldBooleanComponent implements OnInit, OnDestroy, IDatafieldComponent {

  label: string
  session: string
  value: any
  datafield: Datafield
  formControl: FormControl = this.formBuilder.control(false, [Validators.required])
  formControlSubmitted: boolean = false
  subscriptionManager: Subscription = new Subscription()

  constructor(
    private datasheetService: DatasheetService,
    private formBuilder: FormBuilder,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    if (this.value) {
      this.formControl.setValue(this.value)
      this.formControl.disable()
    }
    this.subscriptionManager.add(this.datasheetService.datafieldValidationSubject
      .pipe(tap(() => {
        this.formControlSubmitted = true
        if (this.formControl.invalid) {
          this.datasheetService.everythingIsValid = false
          return
        }
        this.formControlSubmitted = false
      })).subscribe())
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.BOOLEAN, this.label, this.formControl.value)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }
}
